import axios from '../../common/utils/interceptor';
import { apiUrls } from '../../constants';
import { SessionStore } from '../../constants/sessionStore';

export const fetchExperienceProps = async (): Promise<void> => {
  try {
    const response = await axios.get(apiUrls.GET_EXPERIENCE_PROPS);
    if (response.data) sessionStorage.setItem(SessionStore.experienceProps, JSON.stringify(response.data));
  } catch (e) {
    console.error('Error while fetching experience_props: ', e);
  }
};
